import { useState } from 'react'
import styles from './FacultyGrid.module.css'

const beforeSalesServices = [
  { id: 1, title: 'Free Site Visit' },
  { id: 2, title: 'Heat Load Calculation for Tonnage' },
  { id: 3, title: 'Planning & Layouting' },
  { id: 4, title: 'Concealing of Refrigerant Pipe' },
  { id: 5, title: 'Pressure Testing' },
]

const serviceTypes = ['Sales', 'Installation', 'Maintenance']

const categories = [
  {
    id: 'domestic',
    title: 'Domestic Air Conditioners',
    description:
      'High-quality split ACs, window ACs, and portable units designed for residential comfort. We offer products from leading brands with professional installation and after-sales support.',
  },
  {
    id: 'vrf',
    title: 'VRF System',
    description:
      'Variable Refrigerant Flow systems for large-scale commercial applications. Energy-efficient, flexible zoning, and centralized control for optimal climate management.',
  },
  {
    id: 'central',
    title: 'Central Air Conditioners',
    description:
      'Comprehensive central air conditioning solutions for corporate offices, IT parks, and large commercial spaces. Ducted systems engineered for uniform cooling and energy efficiency.',
  },
]

const channelPartners = ['Voltas', 'Blue Star', 'Mitsubishi Electric', 'Daikin']

const FacultyGrid = () => {
  const [activeCategory, setActiveCategory] = useState(null)

  return (
    <section className={styles.section}>
      <div className={styles.container}>
        <div className={styles.approachSection}>
          <h2 className={styles.heading}>Our Approach</h2>
          <p className={styles.approachText}>
            We believe HVAC solutions should be efficient, dependable, and hassle-free. Our approach combines smart planning, quality execution, and responsive support — ensuring every system performs exactly as intended.
          </p>
        </div>

        <div className={styles.beforeSales}>
          <h3 className={styles.subHeading}>Before Sales Services</h3>
          <div className={styles.servicesList}>
            {beforeSalesServices.map((service) => (
              <div key={service.id} className={styles.serviceItem}>
                <span className={styles.serviceNumber}>{service.id}</span>
                <span className={styles.serviceTitle}>{service.title}</span>
              </div>
            ))}
          </div>
        </div>

        <div className={styles.serviceTypesBar}>
          {serviceTypes.map((type, index) => (
            <span key={type} className={styles.serviceType}>
              {type}
              {index < serviceTypes.length - 1 && (
                <span className={styles.separator}>|</span>
              )}
            </span>
          ))}
        </div>

        <div className={styles.categoriesSection}>
          <h3 className={styles.subHeading}>Our Categories</h3>
          <div className={styles.grid}>
            {categories.map((category) => (
              <div
                key={category.id}
                className={`${styles.card} ${activeCategory === category.id ? styles.cardActive : ''}`}
                onClick={() =>
                  setActiveCategory(
                    activeCategory === category.id ? null : category.id
                  )
                }
              >
                <h3 className={styles.cardTitle}>{category.title}</h3>
                {activeCategory === category.id && (
                  <p className={styles.cardDescription}>
                    {category.description}
                  </p>
                )}
                <span className={styles.link}>
                  {activeCategory === category.id ? 'Close' : 'Learn More'} →
                </span>
              </div>
            ))}
          </div>
        </div>

        <div className={styles.partnersSection}>
          <h3 className={styles.partnersTitle}>Authorised Channel Partners of</h3>
          <div className={styles.partnersGrid}>
            {channelPartners.map((partner) => (
              <div key={partner} className={styles.partnerCard}>
                <span className={styles.partnerName}>{partner}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  )
}

export default FacultyGrid
